import React, { createContext, useState, useRef, useEffect } from 'react';
import { Manager_UI } from '../Scripts/Javascript/ERUMAUI';

export const Context_UI = createContext(Manager_UI);

export function Provider_UI({ children }) {
    /*const [Subwindows_Active, Subwindows_Active_Set] = useState([]);
    const [Subwindows_Current, Subwindows_Current_Set] = useState(null);
    const Manager_Ref = useRef();

    useEffect(() => {
        const Manager = new Manager_UI();
        Manager_Ref.current = Manager;
        Manager.Subwindows_Open = (ID) => {
            Subwindows_Active_Set(prev => {
                const New = [...prev, ID];
                Subwindows_Current_Set(ID);
                return New;
            });
        }
        Manager.Subwindows_Close = (ID) => {
            Subwindows_Active_Set(prev => {
                const New = prev.filter(ID_Window => ID_Window !== ID);
                Subwindows_Current_Set(New.length > 0 ? New[New.length - 1] : null);
                return New;
            })
        }
    }, []);

    const Values = {
        Manager_UI: Manager_Ref.current,
        Subwindows_Active: Subwindows_Active,
        Subwindows_Current: Subwindows_Current,
        Subwindows_Open: Manager_Ref.current?.Subwindows_Open,
        Subwindows_Close: Manager_Ref.current?.Subwindows_Close
    }*/
    return(
        <Context_UI.Provider value={Manager_UI}>
            {children}
        </Context_UI.Provider>
    );
}